import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon7",
  "use": "icon7-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon7\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h32v32H0z\" /><path d=\"M16.89 3.506c.302.01.574.099.777.27.16.134.272.318.314.527h0L18.008 11h9.487l-3.472 16H4V11h6.564l5.503-6.861c.132-.34.445-.592.822-.633z\" stroke=\"#FF9A38\" stroke-width=\"4\" /><path fill=\"#FF9A38\" fill-rule=\"nonzero\" d=\"M8 15.5h3.8v7H8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol